import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExternalAccountService } from '../../../../core/services/accounts.service';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-tv-accounts',
  imports: [CommonModule],
  templateUrl: './tv-accounts.html',
  styleUrl: './tv-accounts.scss'
})
export class TvAccounts implements OnInit, OnDestroy {

  movieId: number | null = null;
  movieName: string | null = null;
  accountDetails: any;
  private destroy$ = new Subject<void>();

  constructor(private route: ActivatedRoute, private externalAccountDetails: ExternalAccountService) {}

  ngOnInit(): void {
    this.route.paramMap.pipe(takeUntil(this.destroy$)).subscribe(params => {
      const slug = params.get('slug');
      this.fetchExternalIds(slug);
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  fetchExternalIds(slugParam?: string | null): void {
    const slug = slugParam !== undefined ? slugParam : this.route.snapshot.paramMap.get('slug');
    const [id, name] = slug ? slug.split('-') : [null, null];

    this.movieId = id ? parseInt(id, 10) : null;
    this.movieName = name ? decodeURIComponent(name.replace(/-/g, ' ')) : null;

    if (this.movieId) {
      this.externalAccountDetails.getExternalIds(this.movieId, 'tv').subscribe(accountDetails => {
        this.accountDetails = accountDetails || [];
      });
    }
  }
}

